module.exports = __webpack_public_path__ + "static/media/vegetarianos_checked.621792a6.svg";